import styled from 'styled-components'
import {
  BaseColor,
  Breakpoint,
  breakpointEnding,
  breakpointStarting,
  IconStyled,
  rem,
  spacing,
  themeColor,
  Typography,
} from '@unbounded/unbounded-components'
import { css } from 'styled-components/macro'
import { headerHeight, headerMobileBreakpoint } from '~layout'

export const Page = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${themeColor(BaseColor.min)};
  overflow: hidden;
  min-height: 100%;

  @media (${headerMobileBreakpoint}) {
    margin-top: ${rem(headerHeight)};
  }
`

const circleFormer = css`
  background-color: ${themeColor(BaseColor.shade_90)};

  &::after {
    content: '';
    display: block;
    height: 4rem;
    background-color: ${themeColor(BaseColor.min)};

    @media (${breakpointStarting(Breakpoint.lg)}) {
      height: 6rem;
    }

    @media (${breakpointStarting(Breakpoint.xl)}) {
      height: 8rem;
    }
  }
`

export const ContrastSectionsOpener = styled.div`
  ${circleFormer};
  &::after {
    clip-path: ellipse(58% 200% at 50% 200%);
  }
`

export const Header = styled.div`
  background-color: ${themeColor(BaseColor.shade_90)};
  padding: ${spacing()};
  display: flex;
  align-items: flex-end;
  justify-content: center;
`

export const ArrowContainer = styled.div`
  width: 70%;
  color: ${themeColor(BaseColor.min)};
  margin: 1vw 0 4vw 0;
  position: relative;

  @media (${breakpointEnding(Breakpoint.md)}) {
    width: 90%;
  }
`
export const LogoContainer = styled.div`
  width: 5%;

  ${IconStyled} {
    color: ${themeColor(BaseColor.min)};
    width: 100%;
    height: auto;
  }
`

export const ContentWrap = styled.div`
  background-color: ${themeColor(BaseColor.min)};
  flex-grow: 1;
`

export const Content = styled.div`
  max-width: ${rem(600)};
  margin: 0 auto;
  position: relative;
  padding: 0 ${spacing(3)};

  top: calc(-4rem - 7.5vw);
  margin-bottom: calc(-4rem - 7.5vw);

  @media (${breakpointStarting(Breakpoint.lg)}) {
    top: calc(-6rem - 7.5vw);
    margin-bottom: calc(-6rem - 7.5vw);
  }

  @media (${breakpointStarting(Breakpoint.xl)}) {
    top: calc(-8rem - 7.5vw);
    margin-bottom: calc(-8rem - 7.5vw);
  }
`

export const ArrowTitle = styled.div`
  ${Typography.titleLarge};
  text-align: center;
  position: absolute;
  top: 4vw;
  left: 0;
  width: 100%;

  @media (${breakpointEnding(Breakpoint.md)}) {
    ${Typography.titleMedium};
    top: 6vw;
  }
`
